import React from 'react'
import { Form, Spinner } from 'react-bootstrap'
import MainData from '../Form/FormParts/MainData'
import CommunicationData from '../Form/FormParts/CommunicationData'
import ShippingAddresses from '../Form/FormParts/ShippingAddresses'
import BillingAddress from '../Form/FormParts/BillingAddress'
import JobFunctions from '../Form/FormParts/JobFunctions'
import CostCenterMultiselect from '../Form/FormParts/CostCenterMultiselect'
import OfficeMultiSelect from '../Form/FormParts/OfficeMultiSelect'
import CatalogsTable from '../Form/FormParts/CatalogsTable'
import GroupMemberTable from '../Form/FormParts/GroupMemberTable'
import AccountData from '../Form/FormParts/AccountData'
import StorehouseMultiselect from '../Form/FormParts/StorehouseMultiselect'
import { useEmployeeDataState } from '../../../stores/EmployeeDataProvider'
import { observer } from 'mobx-react-lite'

const AddContentArea = observer(() => {
  const {
    communicationData,
    setCommunicationDataByKey,
    formErrors,
    mainData,
    setMainDataByKey,
    resetErrorByFormKey,
    addresses,
    setAddressesByKey,
    activities,
    setActivitiesByKey,
    accountData,
    loadingUserData,
    setAccountDataByKey,
    showUserData,
    selectableAvtivities,
    submittedCommunicationData,
  } = useEmployeeDataState()
  const type = 'create'
  return (
    <Form>
      <MainData
        mainData={mainData}
        setMainDataByKey={setMainDataByKey}
        formErrors={formErrors}
        resetErrorByFormKey={resetErrorByFormKey}
      />
      <CommunicationData
        communicationData={communicationData}
        setCommunicationDataByKey={setCommunicationDataByKey}
        formErrors={formErrors}
        submittedCommunicationData={submittedCommunicationData}
      />
      <ShippingAddresses
        type={type}
        addresses={addresses}
        setAddressesByKey={setAddressesByKey}
      />
      <BillingAddress
        type={type}
        addresses={addresses}
        setAddressesByKey={setAddressesByKey}
      />
      <JobFunctions
        selectableAvtivities={selectableAvtivities}
        activities={activities}
        setActivitiesByKey={setActivitiesByKey}
        formErrors={formErrors}
        resetErrorByFormKey={resetErrorByFormKey}
      />
      {showUserData ? (
        loadingUserData ? (
          <div className='d-flex align-items-center justify-content-center'>
            <Spinner animation='border' variant='primary' />
          </div>
        ) : (
          <>
            <AccountData
              accountData={accountData}
              setAccountDataByKey={setAccountDataByKey}
              formErrors={formErrors}
              resetErrorByFormKey={resetErrorByFormKey}
            />
            <CostCenterMultiselect
              mainData={mainData}
              setMainDataByKey={setMainDataByKey}
              resetErrorByFormKey={resetErrorByFormKey}
              accountData={accountData}
              setAccountDataByKey={setAccountDataByKey}
            />
            <OfficeMultiSelect
              mainData={mainData}
              setMainDataByKey={setMainDataByKey}
              resetErrorByFormKey={resetErrorByFormKey}
              accountData={accountData}
              setAccountDataByKey={setAccountDataByKey}
            />
            <CatalogsTable
              accountData={accountData}
              setAccountDataByKey={setAccountDataByKey}
            />
            <GroupMemberTable
              accountData={accountData}
              setAccountDataByKey={setAccountDataByKey}
            />
            <StorehouseMultiselect
              accountData={accountData}
              setAccountDataByKey={setAccountDataByKey}
              formErrors={formErrors}
            />
          </>
        )
      ) : null}
    </Form>
  )
})

export default AddContentArea
